import { onMounted, ref } from 'vue';
import axios from '@client/helper/http';
import { profile } from '@client/api';
import { PrivateProfile } from '../types/profile';

// 所有实例共享变量
const privateProfile = ref<PrivateProfile | null>(null);

// 获取用户配置信息
let loaded = false;
async function getPrivateProfile() {
  if (loaded) return;
  loaded = true;
  // /profile/private/query
  const res = await axios.get(profile.private);
  const { data } = res;
  privateProfile.value = data as PrivateProfile;
}
// save 用户配置信息
async function savePrivateProfile(key: keyof PrivateProfile, value: any) {
  if (!privateProfile.value) {
    console.error(`profile key=${key} 不存在`);
    return;
  }
  privateProfile.value[key] = value;
  await axios({
    url: profile.privateSave,
    method: 'post',
    data: { [key]: value }
  });
}

/**
 * dashboard 等页面使用，调用、修改配置
 */
export function usePrivateProfile() {
  onMounted(() => {
    getPrivateProfile();
  });

  return {
    privateProfile,
    getPrivateProfile,
    savePrivateProfile
  };
}
